import { Component, Input, SimpleChanges } from '@angular/core';
import { reportTitals } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';

@Component({
  selector: 'piqet-angular-report-data-source-etails',
  templateUrl: './report-data-source-etails.component.html',
  styleUrls: ['./report-data-source-etails.component.scss'],
})
export class ReportDataSourceEtailsComponent {
  @Input() impactItems: any;
  @Input() isExportFlag: any;
  @Input() isApiCall: any;
  chartId: any;
  reportResource = reportTitals;
  showAllMaterial: any = {
    isMaterial: true,
    isConversion: true,
  };
  @Input() isCheckISO = false;
  @Input() processIncluded: any;
  constructor(private reportService: ReportsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.isCheckISO) {
      this.processIncluded = changes['processIncluded'].currentValue;
    } else {
      this.processIncluded = this.showAllMaterial;
    }
    if (this.isApiCall) {
      this.getDataSourceDetails();
    } else {
      this.impactItems = changes['impactItems'].currentValue;
    }
    this.chartId = 'detailedContributionBarChartContainer' + this.impactItems.scenarioId;
  }

  async getDataSourceDetails() {
    const response = await this.reportService.getDataSourceDetails(
      this.impactItems.scenarioId,
      this.isExportFlag,
      this.impactItems.scenarioId
    );
    this.impactItems = response.data;
  }
}
